import { render, staticRenderFns } from "./VacancyQuestionRow.vue?vue&type=template&id=600b7f26&scoped=true&"
import script from "./VacancyQuestionRow.vue?vue&type=script&lang=js&"
export * from "./VacancyQuestionRow.vue?vue&type=script&lang=js&"
import style0 from "./VacancyQuestionRow.vue?vue&type=style&index=0&id=600b7f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b7f26",
  null
  
)

/* custom blocks */
import block0 from "./VacancyQuestionRow.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyQuestionRow.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VTextarea})
